import React, { useState, useEffect, useRef } from "react";
import styles from "./ShareMenu.module.css";
import {
	fw400,
	fw500,
	primaryTextColor,
	titleM,
	titleS,
	primaryColor,
} from "../../../Global.module.css";
import { connect } from "react-redux";
import CustomRadioButton from "../Button/CustomRadioButton";
import { updateShareOption } from "../../../helpers/api";
import { showLink } from "./showLink";
import { showAccessCode } from "./showAccessCode";
import { useOutsideClick } from "../../../helpers/useOutsideClick";
import SwitchButton from "../Button/SwitchButton";
import { updateSlidesMetaData } from "../../../store/actions/updateSlidesMetaData";
import Routes from "../../../routes.json";
import { nanoid } from "nanoid";
import Loader from "../Loader/Loader";

const shareOptions = {
	PUBLIC: "public",
	PROTECTED: "protected",
};

const ShareMenu = ({ data, closeShareMenu, updateSlidesMetaData }) => {
	const [isShareDisabled, setShareDisable] = useState(true);
	const [state, setState] = useState({
		shareLink: data.shareLink,
		shareOption: data.shareOption,
		accessCode: data.accessCode,
		link:
			"https://" +
			window.location.hostname +
			Routes.ViewPage +
			"/" +
			data.id,
		id: data.id,
	});
	const [updating, setUpdating] = useState(false);

	const ref = useRef();

	useOutsideClick(ref, closeShareMenu);

	useEffect(() => {
		setShareDisable(false);
	}, []);

	const switchShareLink = () => {
		let obj = { ...state };
		!state.shareLink
			? (obj.shareOption = shareOptions.PUBLIC)
			: (obj.shareOption = "");
		obj.shareLink = !state.shareLink;
		setState(obj);
	};

	const optionSelected = (option) => {
		let obj = { ...state };
		obj.shareOption = option;
		if (shareOptions.PROTECTED === option) {
			obj.accessCode = obj.accessCode || nanoid(8);
		}
		setState(obj);
	};

	const changeAccessCode = (e) => {
		let accessCode = e.target.value;
		let obj = { ...state };
		obj.accessCode = accessCode.split(" ").join("");
		setState(obj);
	};

	const updateShareOptionStatus = async () => {
		setUpdating(true);
		if (state.shareLink) {
			if (
				state.shareOption === shareOptions.PUBLIC ||
				(state.shareOption === shareOptions.PROTECTED &&
					state.accessCode)
			) {
				try {
					await updateShareOption(
						state.id,
						state.shareLink,
						state.shareOption,
						state.shareOption === shareOptions.PUBLIC
							? ""
							: state.accessCode
					);
				} catch (e) {}
			}
		} else {
			try {
				await updateShareOption(state.id, state.shareLink);
			} catch (e) {}
		}
		updateSlidesMetaData({
			title: data.title,
			shareLink: state.shareLink,
			shareOption: state.shareOption,
			accessCode:
				state.shareOption === shareOptions.PUBLIC
					? ""
					: state.accessCode,
			link:
				"https://" +
				window.location.hostname +
				Routes.ViewPage +
				"/" +
				data.id,
			id: data.id,
		});
		setUpdating(false);
		closeShareMenu();
	};

	return (
		<div className={styles.shareMenu} ref={ref}>
			<div className={styles.titleBar}>
				<p className={`${primaryTextColor} ${titleS} ${fw400}`}>
					Share Link
				</p>
				<SwitchButton
					disabled={isShareDisabled}
					onClickMethod={switchShareLink}
					checked={state.shareLink}
				/>
			</div>
			<div className={styles.mainBlock}>
				<CustomRadioButton
					activeState={state.shareOption}
					clickMethod={() => optionSelected(shareOptions.PUBLIC)}
					compareState={shareOptions.PUBLIC}
					title="Public"
					subTitle="Anyone who knows the link can view it"
					disabled={!state.shareLink}
				/>
				<CustomRadioButton
					activeState={state.shareOption}
					clickMethod={() => optionSelected(shareOptions.PROTECTED)}
					compareState={shareOptions.PROTECTED}
					title="Protected"
					subTitle="Anyone can view the link with the access code"
					disabled={!state.shareLink}
				/>

				{showLink(state, shareOptions)}
				{showAccessCode(state, shareOptions, changeAccessCode)}
			</div>
			<div className={styles.submitBtn}>
				<button
					className={`${titleM} ${fw500} ${primaryColor}`}
					onClick={updateShareOptionStatus}
				>
					{updating ? <Loader /> : "Done"}
				</button>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({
	updateSlidesMetaData: (payload) => dispatch(updateSlidesMetaData(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShareMenu);
